import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue";
import StreetAutocomplete from "../../../../../Scripts/vue-components/bootstrap-components/street-autocomplete.vue";
import PostalAutocomplete from "../../../../../Scripts/vue-components/bootstrap-components/postal-autocomplete.vue";
import { ProcessTypeEnum, ContractReasonEnum, CustomerTypeEnum, InvoicingMethodEnum, HousingTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import { IContractSettings } from "../../new-contract-vuex-store";
import { IContractViewModel, ICustomerViewModel, ICompanyViewModel, IMeteringPointViewModel, IMembershipTypeViewModel, IPriceListViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { SectionChecker } from "../../Default/common/section";
//import Datepicker from "vuejs-datepicker";
import { fi, sv } from 'vuejs-datepicker/dist/locale'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as moment from "moment-recent";
import { NewContractVueHelper } from "../../new-contract-vue-helper";
import Membership from "../steps/components/membership.vue"


library.add(faQuestionCircle, faExclamationCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

class Checker extends SectionChecker {
    constructor() {
        super();
        this.properties = [
            (contract: IContractViewModel) => contract.MeteringPoint.Address.Zip,
            (contract: IContractViewModel) => contract.MeteringPoint.Address.Street,
            (contract: IContractViewModel) => contract.StartDate,
        ];
        this.validationIds = ["MPZip", "MPStreet", "StartDate"];
    }
}
export let MeteringPointInformationChecker = new Checker();

declare var currentLocale: string;

@Component({
    components: {
        ValidatedFormGroup,
        StreetAutocomplete,
        PostalAutocomplete,
        Membership
        //Datepicker,
    },
    filters: {
        date(value) {
            let m = moment(value);
            if (m.isValid())
                return m.format("DD.MM.YYYY");
            return value;
        }
    },
    computed: {
        datePickerlanguage: function () {
            if (currentLocale === "fi") {
                return "fi";
            }
            //else if (currentLocale === "sv") {
            //    return "sv";
            //}
        },
        // sets minimun date to bootstrap-vue form datepicker
        minDate: function () {
            this.showOldContractStartMessage = false;
            if (this.contract.ContractReason == ContractReasonEnum.PRODUCTCHANGE_DH) {
                if (this.contract.OldFixedPeriodTime && this.contract.OldContractEndDate) {                
                    if (this.contract.StartDate && this.contract.OldContractEndDate >= this.contract.StartDate) {
                        this.contract.StartDate = new Date(this.contract.StartDate).addDays(1);
                    }
                    this.showOldContractStartMessage = true;
                    return new Date(this.contract.OldContractEndDate).addDays(1);
                }
                else if (this.selectedProduct && this.selectedProduct.Name.indexOf("Priima") >= 0) {
                    var priimaStartTime = new Date().addDays(5);
                    if (this.contract.OldContractEndDate && this.contract.OldContractEndDate > priimaStartTime) {
                        priimaStartTime = new Date(this.contract.OldContractEndDate).addDays(1)
                    }
                    return priimaStartTime;
                }
            }
            return this.newContractHelper.getDate(this.startDateMin);
        },
        maxDate: function () {
            let setLimit = new Date();
            return setLimit.addDays(365);
        },
    },
    mounted() {
        $("#mpinformation_mpstreet_field input").removeAttr("aria-controls");
        $("#mpinformation_postalcode_field input").removeAttr("aria-controls");
        $("#startdate-datepicker").attr("aria-label", "Sopimuksen toivottu alkamispäivämäärä");
        $("#meteringpointStreetStr_field input").removeAttr("aria-controls");
        $("#meteringpointPostalCodeStr_field input").removeAttr("aria-controls");
        $("#invoicingStreetStr_field input").removeAttr("aria-controls");
        $("#invoicingPostalCodeStr_field input").removeAttr("aria-controls");
    },
})

export default class MeteringPointInformation extends Vue {

    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get holidays() { return this.$store.state.holidays; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get meteringPoint(): IMeteringPointViewModel { return this.$store.state.contract.MeteringPoint; }
    get customerContracts(): IContractViewModel[] { return this.$store.state.contract.CustomerContracts; }
    get customer(): ICustomerViewModel { return this.contract.Customer; }
    get company(): ICompanyViewModel { return this.contract.Company; }
    get mpStreet(): string { return this.contract.MeteringPoint.Address.Street; }
    get customerStreet(): string { return this.customer ? this.customer.Address.Street : ""; }
    get customerZip(): string { return this.customer ? this.customer.Address.Zip : ""; }
    get companyStreet(): string { return this.company ? this.company.Address.Street : ""; }
    get companyZip(): string { return this.company ? this.company.Address.Zip : ""; }
    get isInvoicingMethodsInUse(): boolean { return this.contractSettings.InvoicingMethodsInUse; }
    get postal(): string { return this.$store.state.contract.MeteringPoint.Address.Zip; }
    get invoicingStreet(): string { return this.contract && this.contract.InvoicingAddress && this.contract.InvoicingAddress.Address ? this.contract.InvoicingAddress.Address.Street : ""; }
    get invoicingZip(): string { return this.contract && this.contract.InvoicingAddress && this.contract.InvoicingAddress.Address ? this.contract.InvoicingAddress.Address.Zip : ""; }
    get availableLanguages(): string[] { return this.contractSettings.AvailableLanguages }
    get additionalAddressToMeteringPointAddress(): boolean { return this.contract.MeteringPoint.AdditionalAddressToMeteringPointAddress; }
    get meteringPointCode(): string { return this.contract.MeteringPoint.MeteringPointCode; } set meteringPointCode(value: string) { }
    get gsrnCode(): string { return this.contract.MeteringPoint.GsrnCode; } set gsrnCode(value: string) { }
    get disableMeteringPointcodeField(): boolean { return this.meteringPoint.TrustedSource }
    get contractReasonMoveIn(): ContractReasonEnum { return ContractReasonEnum.MOVEIN_DH }
    get contractReasonSupplierChange(): ContractReasonEnum { return ContractReasonEnum.SUPPLIERCHANGE_DH }
    get contractReasonContractChange(): ContractReasonEnum { return ContractReasonEnum.PRODUCTCHANGE_DH }
    get preSelectedMembership(): string { return this.$store.state.preSelectedMembership; }
    get selectedProduct(): IPriceListViewModel { return this.$store.state.selectedProduct; }
    get selectedPriceList(): IPriceListViewModel { return this.$store.state.selectedPriceList; }
    get isPriimaPlus(): boolean {
        return this.contractSettings.PriimaPlusProductId && this.contractSettings.PriimaPlusProductId > 0
            && this.contract.ProductId == this.contractSettings.PriimaPlusProductId;
    }
    get isPriima(): boolean {
        return this.contractSettings.PriimaProductId && this.contractSettings.PriimaProductId > 0
            && this.contract.ProductId == this.contractSettings.PriimaProductId;
    }
    get offerRequest(): boolean { return this.$store.state.offerRequest; }

    @Prop()
    public validationErrors: any;

    @Prop({ default: false })
    public hasMembership: boolean

    ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;
    ContractReasonEnum: typeof ContractReasonEnum = ContractReasonEnum;
    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;
    InvoicingMethodEnum: typeof InvoicingMethodEnum = InvoicingMethodEnum;
    HousingTypeEnum: typeof HousingTypeEnum = HousingTypeEnum;

    startDate = this.contract.StartDate;
    tempDate: Date = new Date(); //SQI4U-1113 
    postalModel: string = "";
    postalStr: string;

    //SQI4U-1113, when reverting, change tempdate -> startDate in both lines below
    @Watch("startDate")
    startDateChanged(v1, v2) {
        this.$store.dispatch("changeValue", { key: "StartDate", value: moment(String(this.startDate)).format('DD.MM.YYYY') });
    }
    //SQI4U-1113
    @Watch("tempDate")
    tempDateChanged(v1, v2) {
        this.startDate = this.tempDate;
    }
    //SQI4U-1113 end

    mpStreetStr: string;

    customerZipStr: string;
    customerStreetStr: string;

    companyZipStr: string;
    companyZipLocale: string;
    companyStreetStr: string;
    companyStreetLocale: string;

    invoicingStreetStr: string;
    invoicingStreetLocale: string;
    invoicingZipStr: string;
    invoicingZipLocale: string;

    estateOwner: boolean;

    mpStreetLocale: string = null;
    mpZipLocale: string = null;

    customerStreetLocale: string = null;
    customerZipLocale: string = null;

    newContractHelper: NewContractVueHelper;
    showOldContractStartMessage: boolean = false;

    showInvoicingAddressSection: number = 0;

    constructor() {
        super();
        this.mpStreetStr = this.mpStreet;
        this.customerStreetStr = this.customerStreet;
        this.customerZipStr = this.customerZip;
        this.companyStreetStr = this.companyStreet;
        this.companyZipStr = this.companyZip;
        this.postalStr = this.postal;
        this.invoicingStreetStr = this.invoicingStreet;
        this.invoicingZipStr = this.invoicingZip;
        this.estateOwner = this.contract.IsEstateOwner;
        this.invoicingZipLocale = null;
        this.invoicingStreetLocale = null;
        this.newContractHelper = new NewContractVueHelper();       
    }

    mounted() {
        if (this.contract.InvoicingMethod == InvoicingMethodEnum.ConsumerEInvoice && this.contract.InvoicingAddress != null && this.contract.InvoicingAddress.Address != null && this.contract.InvoicingAddress.Address.Street != null) {
            this.showInvoicingAddressSection = 1;
        }
    }

    @Watch("mpStreet")
    keepMpSync() {
        this.mpStreetStr = this.mpStreet;
        console.log("mpStreet: " + this.mpStreet);
    }

    @Watch("customerStreet")
    keepCusSync() {
        this.customerStreetStr = this.customerStreet;
    }

    @Watch("companyStreet")
    keepComSync() {
        this.companyStreetStr = this.companyStreet;
    }

    @Watch("invoicingStreet")
    keepinvoicingSync() {
        this.invoicingStreetStr = this.invoicingStreet;
    }

    @Watch("postal")
    keepSync() {
        this.postalStr = this.postal;
    }

    afterEnter_mp(el) {
        $("#meteringpointStreetStr_field input").removeAttr("aria-controls");
        $("#meteringpointPostalCodeStr_field input").removeAttr("aria-controls");
    }
    afterEnter_inv(el) {
        $("#invoicingStreetStr_field input").removeAttr("aria-controls");
        $("#invoicingPostalCodeStr_field input").removeAttr("aria-controls");
    }

    get isMoveOut() {
        return this.contract.ProcessType == ProcessTypeEnum.MOVEOUT;
    }

    get startDateMin(): string {
        return this.newContractHelper.startDateMin_DH(this.contract, this.contractSettings);
    }

    get startDateMax(): string {
        let max = moment();
        max.add("y", 1);
        let maxStr = max.format("DD.MM.YYYY") + " 00:00:00 GMT";
        return maxStr;
    }

    get hasConsumerEInvoiceContract(): boolean {
        //if (this.contract != null && this.contract.CustomerContracts) {
        //    for (let cisContract of this.contract.CustomerContracts) {
        //        if (cisContract.InvoicingMethod == InvoicingMethodEnum.ConsumerEInvoice) return true;
        //    }
        //}
        return false;
    }

    get invoicingMethodELaskuStr(): string {
        if (this.hasConsumerEInvoiceContract) {
            return "Sinulla on käytössä pankin e-laskutus. Et voi valita toista laskutustapaa ennen kun olet peruuttanut e-laskutuksen pankista.";
        }
        return "";
    }

    get invoicingMethodELaskuStrDisabled(): string {
        if (!this.hasConsumerEInvoiceContract) {
            return "E-laskun voit tilata omasta verkkopankistasi saatuasi ensimmäisen laskun.";
        }
        return "";
    }

    get tooltipStyle(): any {
        if (this.additionalAddressToMeteringPointAddress) {
            return { color: 'red' };
        }
        return { color: 'white' };
    }

    contractReasonChanged() {
        console.log("Contract reason changed!");
        if (this.contract.StartDate != null) {
            let m = moment(this.contract.StartDate);
            let min = moment(this.startDateMin, "DD.MM.YYYY");
            if (m.isBefore(min)) {
                //SQI4U-1113 the commented out lines are from pre-1113
                //let newDate = min.format("DD.MM.YYYY");
                //this.$store.dispatch("changeValue", { key: "StartDate", value: newDate });
                this.startDate = new Date(moment(String(this.startDateMin)).format("DD.MM.YYYY"));
            }
        }
    }

    invoicingMethodChanged() {
        if ((this.contract.InvoicingMethod == InvoicingMethodEnum.Email) && (this.contract.DeliveryEmail == null || this.contract.DeliveryEmail.length == 0)) {
            this.contract.DeliveryEmail = (this.contract.CustomerType != CustomerTypeEnum.COMPANY) ? this.customer.Email : this.company.Email;
            this.$store.dispatch("changeValue", { key: "DeliveryEmail", value: this.contract.DeliveryEmail });
        }
        if (this.contract.InvoicingMethod == InvoicingMethodEnum.Email) {
            this.showInvoicingAddressSection = 0;
        }
    }

    // returns true for dates to disable
    // ymd: The date as a YYYY-MM-DD string
    // date: The date as a Date object
    disableDates(ymd: string, date: Date): boolean { // used by bootstrap-vue form datepicker
        this.contractSettings.ProductChangeMinDates
        //if (this.isPriima) {
        //    const day = date.getDate()
        //    return day > 1;
        //}
        
        //let weekend = [0, 6];
        //return this.newContractHelper.disableDates(date, weekend, this.holidays);
        return false;
    }

    data() {
        return {
            selected: 'ei',
            options: [
                { text: this.$t('Kyllä'), value: true },
                { text: this.$t('Ei'), value: false }
            ],
            DatePickerFormat: "dd.MM.yyyy"
        };
    }

    meteringPointPostalSelected(postCode: string, locale: string) {
        this.postalStr = postCode;
        this.mpZipLocale = locale;
        this.$store.dispatch("changeValue", { key: "MPZip", value: postCode, locale: locale })
            .then(() => { this.$store.dispatch("checkMeteringPointAndContract"); });
    }

    meteringPointStreetSelected(street: string, locale: string) {
        this.mpStreetStr = street;
        this.mpStreetLocale = locale;
        this.$store.dispatch("changeValue", { key: "MPStreet", value: street })
            .then(() => { this.$store.dispatch("checkMeteringPointAndContract"); });
    }

    customerPostalSelected(postCode: string, locale: string) {
        this.customerZipStr = postCode;
        this.customerZipLocale = locale;
        this.$store.dispatch("changeValue", { key: "Zip", value: postCode, locale: locale });
    }

    customerStreetSelected(street: string, locale: string) {
        this.customerStreetStr = street;
        this.customerStreetLocale = locale;
        this.$store.dispatch("changeValue", { key: "Street", value: street });
    }

    companyPostalSelected(postCode: string, locale: string) {
        this.companyZipStr = postCode;
        this.companyZipLocale = locale;
        this.$store.dispatch("changeValue", { key: "CompanyZip", value: postCode, locale: locale });
    }

    companyStreetSelected(street: string, locale: string) {
        this.companyStreetStr = street;
        this.companyStreetLocale = locale;
        this.$store.dispatch("changeValue", { key: "CompanyStreet", value: street });
    }

    invoicingPostalSelected(postCode: string, locale: string) {
        this.invoicingZipStr = postCode;
        this.invoicingZipLocale = locale;
        this.$store.dispatch("changeValue", { key: "InvoicingZipCompany", value: postCode, locale: locale });
    }

    invoicingStreetSelected(street: string, locale: string) {
        this.invoicingStreetStr = street;
        this.invoicingStreetLocale = locale;
        this.$store.dispatch("changeValue", { key: "InvoicingStreetCompany", value: street });
    }
    showIsEstateOwnerSection(housingTypeId: HousingTypeEnum) {
        if (housingTypeId == HousingTypeEnum.HOUSE || housingTypeId == HousingTypeEnum.TERRACEDORDOUBLEHOUSE || housingTypeId == HousingTypeEnum.COTTAGE) {
            return true;
        }
        return false;
    }

    getMemberShipType() {
        if (this.contract && this.contract.Customer && this.contract.Customer.CustomerMemberships.length > 0) {
            return this.contract.Customer.CustomerMemberships[0].MembershipTypeId;
        } else {
            return 0;
        }
    }

    isPreSelectedMembership(membership: string): boolean {
        return this.preSelectedMembership && this.preSelectedMembership.toLocaleLowerCase() == membership;
    }

    hasPreSelectedMembership(): boolean {
        let membership = this.preSelectedMembership;
        let membershipTypes = this.$store.state.membershipTypes as IMembershipTypeViewModel[];
        let membershipType: IMembershipTypeViewModel = null;

        if (membership && membershipTypes) {
            membershipType = membershipTypes.find(m => m.Name == membership);
        }
        else {
            return false;
        }

        if (this.contract.MembershipCode != membership && membershipType) {
            this.$store.dispatch("changeValue", { key: "MembershipType", value: membershipType.MembershipTypeId }).then(() => {
                this.$store.dispatch('updateExtraFeature', { name: membership, amount: 0, price: 0 }).then(() => {
                    this.contract.MembershipCode = membership;
                    this.contract.PreSelectedMembership = membership;
                    return true;
                });
            });
        }
        if (membership && this.contract.MembershipCode && this.contract.MembershipCode == membership) {
            return true;
        }
        return false;
    }

    getOldProductName(): string {
        return (this.contract.OldContractsProduct && this.contract.OldContractsProduct.ProductName) ? this.contract.OldContractsProduct.ProductName + '-' : "";
    }

    showNewContractStartDateText(oldContractEndDate: string) {
        let retValue = false;
        if (oldContractEndDate) {
            let endDate = moment(oldContractEndDate);
            if (endDate > moment()) {
                retValue = true;
            }
        }
        return retValue;
    }
}